/**
 * Plain-language meaning of every error the terminal can return, taken verbatim
 * from Tinda-ERP-Doc-main/errors.md so a cashier sees an explanation rather
 * than a constant.
 */
export const TERMINAL_ERRORS = {
  UsersEmpty: "No users were found on the terminal",
  UserNotFound: "No user with this name was found on the terminal",
  WrongPassword: "Wrong password",
  UserAlreadyLogined: "The user is already logged in",
  UndefinedError: "Unknown error",
  BadRequest: "The request is corrupted or has an incorrect format",
  EmptyFmSettings: "Fiscal module settings not found",
  NoLoginedUser: "There is no authorized user, please log in",
  AdvanceNotFullyPaid: "Can't register advance before it is fully paid",
  SaleNotFound: "Sale not found",
  KKMIsBusy: "Terminal is busy, processing the request",
  SaleIsNotCreditPrepayment: "The sale is not an credit/prepayment type",
  CreditPaid: "This credit fully paid off",
  PrepaymentPaid: "This advance fully paid off",
  NoCashedReceipt: "The last registered receipt was not found",
  PSIDError: "Products found without PSID, sale registration canceled",
  FailToGetSaleFromServer: "Error occured while receiving a sale from the server",
  WrongAmount: "Incorrect data about the sale amount",
  WrongDiscount: "Incorrect data about the amount of discounts",
  SkPaymentNotFound: "There is no application found on the terminal for performing card transactions, please contact support for help",
  SKPaymentTransactionError: "Card transaction Error",
  TransactionVoidOperationError: "Cancellation of payment by card for the current refund is not possible. The client needs to contact his bank to perform a refund operation on the card",
  NoSuchProductInSale: "No such product was found on sale",
  TooManyProductAmountForRefund: "Error in the quantity of returned goods",
  NotAvailableProductLabelForRefund: "Error in some of refunded product labels",
  WrongProductPrice: "Wrong product price",
  WrongProductDiscount: "Wrong product discount",
  WrongPayments: "Some error in received payments",
  AllProductsRefunded: "There are no products available for return for this sale",
  NoOFDConnection: "Unable to connect to server",
  ReceiptCountZero: "There are no receipts in FM memory",
  ReceiptIndexOutOfBounds: "The transmitted receipt number is less than 0 or more than the number of receipts in the FM",
  ReceiptNotFound: "Receipt not found",
  DataSizeNotSupported: "Passed FullReceiptHash and TOTAL_BLOCK of invalid length",
  ReceiptFormatInvalid: "Passed TOTAL_BLOCK with invalid fields",
  ReceiptVatOverflow: "Overflow of the VAT field when summing up with the accumulated VAT field",
  ReceiptSeqOverflow: "Overflow of the receipt number field",
  ReceiptCashOverflow: "Overflow of the CASH field when summing with the accumulated CASH field",
  ReceiptCardOverflow: "Overflow of the CARD field when summing with the accumulated CARD field",
  ReceiptMemoryFull: "The receipt storage memory is full. You should send receipt files to the OFD server and receive confirmation.",
  ReceiptTimePast: "Passed the past date and time of the receipt. The date and time of the receipt must differ by at least 1 sec from the date of the previous receipt or the opening of the Z-report",
  ReceiptStoreDaysLimitExceeded: "There are receipts in memory that were not sent on time. You should send receipt files to the OFD server and receive confirmation.",
  AcknowledgeWrongLength: "Uploaded ack file has an invalid length",
  AcknowledgeSignatureInvalid: "The transferred ack file has an invalid signature. Perhaps an ack-file was transferred that was not intended for this FM",
  AcknowledgeTerminalIdMismatch: "Perhaps an ack-file was transferred that was not intended for this FM",
  OpenCloseZreportWrongLength: "The passed datetime value has an invalid length",
  CloseZreportTimePast: "Passed the past date and time when the Z report was closed. Date and time of Z-report closing must differ by at least 1 second. from the date of the previous receipt",
  ZreportSpaceIsFull: "The Z-record storage memory is full. FM should be replaced with a new one",
  ZreportIndexOutOfBounds: "The transmitted Z-report sequence number is less than 0 or greater than the number of Z-reports in the FM",
  CurrentZreportIsEmpty: "Attempting to close an empty Z-report",
  ZreportIsNotOpen: "Z-report was not opened",
  SaleRefundCountOverflow: "The number of sales or refunds transactions in the current Z-report has been exceeded. Close the current Z-report and open a new Z-report",
  ZreportIsAlreadyOpen: "Z-report has already been opened",
  NotEnoughCashForRefund: "Not enough CASH to refund",
  NotEnoughCardForRefund: "Not enough CARD to refund",
  NotEnoughVatForRefund: "Not enough VAT to refund",
  OpenZreportTimePast: "Passed the past date and time when the Z-report was opened. Date and time of Z-report opening must differ by at least 1 second. from the date of time of the previous closed Z-report",
  PrinterBusy: "Printer is busy",
  PaperEnded: "Out of paper",
  PrinterBroken: "Printer malfunctions",
  PrinterOverheated: "Printer over heats",
  PrinterLowEnergy: "Printer voltage is too low",
  PrintIsNotFinished: "Printing is unfinished",
  PrinterLostFonts: "The printer has not installed font library",
  TooLongReceipt: "Data package is too long",
  PrinterIsNotFound: "Dal printer is not found",
};

export const explainTerminalError = (code) =>
  TERMINAL_ERRORS[code] || code || "Unknown terminal error";
